import SvgIcon from "@mui/material/SvgIcon";
import { AwsIcon, AzureIcon, BracketsIcon, GcpIcon, GithubIcon } from "~/icons";
import { OrganizationScope, ScopeType, SpaceScope } from "~/hooks/useScope";

export type WifScope = SpaceScope | OrganizationScope;

export function getWifSettingsBasePath(scope: WifScope): string {
  return scope.type === ScopeType.Organization
    ? "/organization/settings"
    : "/space/settings";
}

export type ProviderTypes = "aws" | "azure" | "google" | "github" | "custom";

type AvailableProvidersType = {
  issuerUrl: string;
  type: ProviderTypes;
  title: string;
  description: string;
  icon: typeof SvgIcon;
};

export const customProvider: AvailableProvidersType = {
  issuerUrl: "",
  type: "custom",
  title: "Custom",
  description:
    "Add your own, custom method for providing keyless workload authentication using OpenID Connect.",
  icon: BracketsIcon,
};

export const availableProviders: Array<AvailableProvidersType> = [
  {
    issuerUrl: "https://sts.amazonaws.com",
    type: "aws",
    title: "AWS",
    description: "Use AWS IAM roles for keyless authentication with Mondoo.",
    icon: AwsIcon,
  },
  {
    issuerUrl: "https://sts.windows.net/TENANT-ID",
    type: "azure",
    title: "Azure",
    description:
      "Use Microsoft Entra Workload ID for keyless authentication with Mondoo.",
    icon: AzureIcon,
  },
  {
    issuerUrl: "https://accounts.google.com",
    type: "google",
    title: "Google",
    description:
      "Use Google Cloud Workload Identity Federation for keyless authentication with Mondoo.",
    icon: GcpIcon,
  },
  {
    issuerUrl: "https://token.actions.githubusercontent.com",
    type: "github",
    title: "GitHub",
    description:
      "Use GitHub's OpenID Connect provider for keyless authentication with Mondoo.",
    icon: GithubIcon,
  },
  customProvider,
];
